import React from 'react';
import PropTypes from 'prop-types';
import ListDetailsFoods from '../components/ListDetailsFoods';
import FinishButton from '../components/FinishButton';
import BackButton from '../components/BackButton';

function FoodsProgress(props) {
  const { match: { params: { id } } } = props;
  const { location: { pathname } } = props;
  return (
    <div className="d-progress">
      <BackButton />
      <ListDetailsFoods id={ id } pathname={ pathname } />
      <FinishButton id={ id } type="food" />
    </div>
  );
}

FoodsProgress.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.string }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string }).isRequired,
};

export default FoodsProgress;
